import { ProSidebarProvider } from "react-pro-sidebar";
import React, { useEffect } from "react";
import Routes from "./Routes";
import RootNavigator from "Routes/RootNavigator/RootNavigator";
import { messaging, onMessage } from "./config/firebase";

function App() {
  useEffect(() => {
    if (!messaging) return;

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("Foreground notification:", payload);
      if (payload.notification) {
        try {
          new Notification(payload.notification.title || "Notification", {
            body: payload.notification.body,
          });
        } catch (err) {
          console.warn("Notification display failed:", err);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <ProSidebarProvider>
      <RootNavigator />
    </ProSidebarProvider>

  );
}

export default App;
